import SidebarComponent from "../../components/Sidebar/SidebarComponent";
import { useEffect, useState } from "react";
import { getTechnicalSupportByIdUserRequestService } from "./services/technicalSupport.services";
import { TechnicalSupportData } from "./models/technicalSupport.model";
import FormTechnicalSupport from "./components/FormTechnicalSupport";
import TableTechnicalSupport from "./components/TableTechnicalSupport";
import { dataTabletechnicalSupportAdapter as dataTableTechnicalSupportAdapter } from "./adapters/technicalSupport.adapters";
import { ToastControlBackendModel } from "../../components/Sidebar/ToastBackControl/models/toastBackControl.model";
import ToastBackControl from "../../components/Sidebar/ToastBackControl/ToastBackControl";

const viewStyles = `
  @import url('https://fonts.googleapis.com/css2?family=Plus+Jakarta+Sans:wght@400;500;600;700;800&display=swap');

  .support-root-container {
    font-family: 'Plus Jakarta Sans', sans-serif;
    background-color: #f8fafc; /* Fondo gris claro */
    min-height: 100vh;
    display: flex;
  }

  .support-main-content {
    flex-grow: 1;
    padding: 2rem 2.5rem;
    max-width: 1400px;
    margin: 0 auto;
    width: 100%;
  }

  .support-card {
    background: #ffffff;
    border: 1px solid #e2e8f0;
    border-radius: 20px;
    box-shadow: 0 10px 25px -5px rgba(0, 0, 0, 0.02);
    padding: 2.5rem;
    animation: fadeInSupport 0.4s ease-out;
  }

  @keyframes fadeInSupport {
    from { opacity: 0; transform: translateY(12px); }
    to { opacity: 1; transform: translateY(0); }
  }

  .support-icon-box {
    background-color: #e6faf2;
    color: #00A86B;
    border-radius: 12px;
    padding: 0.75rem;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .empty-reports-box {
    background: #f9fafb;
    border: 1.5px dashed #e5e7eb;
    border-radius: 14px;
    padding: 3rem 1.5rem;
  }

  @media (max-width: 768px) {
    .support-main-content { padding: 1.25rem; }
    .support-card { padding: 1.5rem; border-radius: 16px; }
  }
`;

function TechnicalSupport(): JSX.Element {
  const idUser = localStorage.getItem("idUser");
  const [technicalSupportData, setTechnicalSupportData] = useState<TechnicalSupportData[]>([]);
  const [messageBackend, setMessageBackend] = useState<ToastControlBackendModel>({
    severityValue: "info",
    detailValue: "",
    lifeValue: 3000,
    validateShowMessage: false,
  });

  const getAllTechnicalSupportByUser = async (): Promise<void> => {
    try {
      if (idUser) {
        const response = await getTechnicalSupportByIdUserRequestService(+idUser);
        if (response.data) {
          setTechnicalSupportData(response.data);
        } else {
          setTechnicalSupportData([]);
        }
      } else {
        window.location.href = "/";
      }
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    getAllTechnicalSupportByUser();
  }, []);

  return (
    <div className="support-root-container">
      <style>{viewStyles}</style>
      <SidebarComponent />
      
      {messageBackend.validateShowMessage && (
        <ToastBackControl
          validateShowMessage={messageBackend.validateShowMessage}
          detailValue={messageBackend.detailValue}
          lifeValue={messageBackend.lifeValue}
          severityValue={messageBackend.severityValue}
        />
      )}

      {idUser && (
        <main className="support-main-content">
          <div className="support-card">
            
            {/* Header de la Vista */}
            <div className="flex align-items-center justify-content-between pb-4 border-bottom-1 surface-border mb-5">
              <div className="flex align-items-center gap-3">
                <div className="support-icon-box shadow-1">
                  <i className="pi pi-headphones text-xl"></i>
                </div>
                <div className="flex flex-column">
                  <h1 className="text-xl md:text-2xl font-bold m-0 tracking-tight" style={{ color: '#1e293b' }}>
                    Contacta a Soporte Técnico
                  </h1>
                  <p className="text-sm text-500 m-0 mt-1 hidden sm:block">
                    Envía tus dudas o reportes y haz seguimiento a las soluciones brindadas por nuestro equipo.
                  </p>
                </div>
              </div>
            </div>

            {/* Formulario de envío */}
            <div className="mb-5">
              <FormTechnicalSupport
                idUser={+idUser}
                getAllTechnicalSupportByUser={getAllTechnicalSupportByUser}
                setMessageBackend={setMessageBackend}
              />
            </div>

            {/* Listado o Mensaje Vacío */}
            <div className="mt-4">
              <h3 className="text-base font-bold mb-3" style={{ color: '#475569' }}>Tus reportes recientes</h3>
              {technicalSupportData.length > 0 ? (
                <TableTechnicalSupport
                  technicalSupportData={dataTableTechnicalSupportAdapter(technicalSupportData)}
                />
              ) : (
                <div className="empty-reports-box text-center">
                  <i className="pi pi-folder-open text-3xl text-400 mb-2 block"></i>
                  <p className="text-base font-semibold m-0 text-600">Aún no tienes reportes creados</p>
                  <p className="text-xs text-400 m-0 mt-1">Las consultas que envíes aparecerán listadas en esta sección.</p>
                </div>
              )}
            </div>

          </div>
        </main>
      )}
    </div>
  );
}

export default TechnicalSupport;